import { Limits as LimitsGlobal } from 'app/common/components/Cafeteria/CafeteriaSettings'


type Props = {
  orgID: string
  accountID: string
  splitLimitEnabled: boolean
}

export const Limits = ({ orgID, accountID, splitLimitEnabled }: Props) => {
  // TODO Вынести сюда баннер

  return (
    <LimitsGlobal
      orgID={orgID}
      customerID={accountID}
      splitLimitEnabled={splitLimitEnabled}
    />
  )
}
